export default "__VITE_ASSET__BAShRvx5__"